import React from 'react';
import {
  IBasicConnectionInput,
  StrategyKind,
} from '../../../../utils/apollo/graphqlSchema';
import { TextAreaField, VerticalField } from '../../../../components/Form';
import { CDW_STRATEGY_OPTS } from './utils';
import { WideSingleSelectMenu } from './DataModelerDataSourceInputUI';
import { DataModelerConfigLabelWithInfo } from '../DataModelerShared';
import { dataModelLabelInfoTooltipOptions } from '../../../../components/KubitTooltip/globalTooltips';
import QueryTimeoutField from './QueryTimeoutField';
import { DataModelerBasicAuthenticationType } from './DataModelerBasicAuthenticationType';

interface IProps {
  readOnly: boolean;
  canEditProps: boolean;
  basicInput: IBasicConnectionInput;
  setBasicInput: (basicInput: IBasicConnectionInput) => void;
}

const DataModelerBasicConnectionInput = ({
  readOnly,
  canEditProps,
  basicInput,
  setBasicInput,
}: IProps) => {
  const { strategy, jdbcUrl, timeout } = basicInput;

  const setStrategy = (kindStr: string) => {
    const kind = kindStr as StrategyKind;
    setBasicInput({
      ...basicInput,
      strategy: kind,
    });
  };

  const setJdbcUrl = (newJdbcUrl: string) => {
    setBasicInput({
      ...basicInput,
      jdbcUrl: newJdbcUrl,
    });
  };

  const setTimeoutSecStr = (newTimeout: number | null) => {
    setBasicInput({
      ...basicInput,
      timeout: newTimeout,
    });
  };

  return (
    <>
      <VerticalField noMargin={true}>
        <DataModelerConfigLabelWithInfo
          labelText={'Warehouse Type'}
          tooltipOption={
            dataModelLabelInfoTooltipOptions.connectionWarehouseType
          }
        />
        <WideSingleSelectMenu
          disabled={!canEditProps}
          value={strategy}
          onChange={setStrategy}
          options={CDW_STRATEGY_OPTS}
        />
      </VerticalField>

      <DataModelerBasicAuthenticationType
        readOnly={readOnly}
        canEditProps={canEditProps}
        basicInput={basicInput}
        setBasicInput={setBasicInput}
      />

      <QueryTimeoutField
        timeout={timeout}
        onChange={setTimeoutSecStr}
        disabled={!canEditProps}
      />
      <VerticalField noMargin={true}>
        <DataModelerConfigLabelWithInfo
          labelText={'JDBC URL'}
          tooltipOption={dataModelLabelInfoTooltipOptions.connectionJdbcUrl}
        />
        <TextAreaField
          minRows={2}
          maxRows={2}
          disabled={!canEditProps}
          value={jdbcUrl}
          onChange={setJdbcUrl}
        />
      </VerticalField>
    </>
  );
};

export default DataModelerBasicConnectionInput;
